export const getCouponContent = store => (store.coupon ? store.coupon : {});
export const getCoupon = store => {
  return getCouponContent(store).coupon;
};
export const isLoaded = store => {
  let content = getCouponContent(store);
  return content.isLoaded != null && content.isLoaded;
};
